<div class="row">
  <mat-form-field appearance="fill">
    <mat-label>{{ label }}</mat-label>

    <mat-date-range-input [rangePicker]="picker" [formGroup]="form" [dateFilter]="dateFilterFn()">
      <input readonly matStartDate formControlName="fromDate" placeholder="Desde" />
      <input readonly matEndDate formControlName="toDate" placeholder="Hasta" />
    </mat-date-range-input>

    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

    <mat-date-range-picker #picker></mat-date-range-picker>
    <mat-hint *ngIf="errorMessage">
      <mat-error>{{errorMessage}}</mat-error>
    </mat-hint>
  </mat-form-field>
</div>